import { typeCategories, filterRegions, filterYears, filterTags } from "@/mocks/site";

interface Selection {
  types: string[];
  regions: string[];
  years: string[];
  tags: string[];
}

interface Props {
  selection: Selection;
  onToggle: (key: keyof Selection, value: string) => void;
  onReset: () => void;
}

function FilterGroup({
  title,
  options,
  selected,
  onToggle,
}: {
  title: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
}) {
  return (
    <div className="py-5 border-b border-background-200/70 last:border-b-0">
      <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = selected.includes(opt);
          return (
            <button
              key={opt}
              onClick={() => onToggle(opt)}
              className={`px-3 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors cursor-pointer ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 border border-background-200/70 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterSidebar({ selection, onToggle, onReset }: Props) {
  const hasAny =
    selection.types.length || selection.regions.length || selection.years.length || selection.tags.length;

  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg px-5 md:px-6">
      <div className="flex items-center justify-between pt-5 pb-1">
        <h3 className="font-heading text-base font-semibold text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选条件
        </h3>
        {hasAny && (
          <button
            onClick={onReset}
            className="text-xs text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            重置筛选
          </button>
        )}
      </div>
      <FilterGroup
        title="类型"
        options={typeCategories.map((c) => c.key)}
        selected={selection.types}
        onToggle={(v) => onToggle("types", v)}
      />
      <FilterGroup
        title="地区"
        options={filterRegions}
        selected={selection.regions}
        onToggle={(v) => onToggle("regions", v)}
      />
      <FilterGroup
        title="年份"
        options={filterYears}
        selected={selection.years}
        onToggle={(v) => onToggle("years", v)}
      />
      <FilterGroup
        title="热门标签"
        options={filterTags}
        selected={selection.tags}
        onToggle={(v) => onToggle("tags", v)}
      />
    </div>
  );
}